import { Injectable, Inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { CommonUtilty } from '../utilities/commonUtility';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class InvestigationService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        private commonUtilty: CommonUtilty,
        private http: HttpClient
    ) { }


    nullifyTransactionEmitters() {
        let nullValue = null;
        let emptyObject = {};
        let emptyArray = [];
        this.currentInvestigationGuid$.next(nullValue);
        // this.newlyAddedRemarksList = emptyArray;
    }

    currentInvestigationGuid$ = new Subject<any>();
    setCurrentInvestigationGuid(guid: string) {
        this.currentInvestigationGuid$.next(guid);
    }
    
    claimFraudPrediction(data: any): Observable<any> {
        let claimFraudPredictionSubject = new Subject<any>();

        const headers = { 'Content-Type': 'application/json' };
        const body = data;
        this.http.post<any>('http://20.204.31.131:8080/model_predict', body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                claimFraudPredictionSubject.next(returnObj);
            },err => {
                claimFraudPredictionSubject.next(err);
            });
            
        return claimFraudPredictionSubject;
    }

    retrainingFWA(data: any): Observable<any> {
        let retrainingFWASubject = new Subject<any>();

        const headers = { 'Content-Type': 'application/json' };
        const body = data;
        this.http.post<any>("http://20.204.31.131:8080/model_build", body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                retrainingFWASubject.next(returnObj);
            });
            
        return retrainingFWASubject;
    }

    predictEarlyClaim(data){
        let predictEarlyClaim = new Subject<any>();
        const headers = { 'Content-Type': 'application/json' };
        const body = data;
    
        let URL = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/nbu/predict_claim_time_taken'
        this.http.post<any>(URL, body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                predictEarlyClaim.next(returnObj);
            },err => {
                predictEarlyClaim.next(err);
            });
        return predictEarlyClaim;
    }

    fetchSimilarCases(data){
        let similarCasesUW = new Subject<any>();
        const headers = { 'Content-Type': 'application/json' };
        const body = data;
    
        let URL = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/nbu/recommend_similar_policy'
        this.http.post<any>(URL, body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                similarCasesUW.next(returnObj);
            },err => {
                similarCasesUW.next(err);
            });
        return similarCasesUW;
    }
    
}